import { FundGroup } from 'app/models/fund-group'
import { FundGroupsState } from './reducer'

type StateWithFundGroups = { fundGroups: FundGroupsState }

export const getFundGroups = (state: StateWithFundGroups): FundGroup[] =>
  state.fundGroups.groups

export const getFundGroupsForFundManager = (
  state: StateWithFundGroups,
  fundManagerId: string | undefined,
): FundGroup[] =>
  fundManagerId
    ? state.fundGroups.groups.filter(g => g.fundManagerId === fundManagerId)
    : []

export const getFundGroupsLoading = (state: StateWithFundGroups): boolean =>
  state.fundGroups.isLoading
